import Vue from "vue";
import { Component } from "vue-property-decorator";

import { FetchWrapper } from "../../infrastructure/fetch-wrapper";

import "datatables.net";
import "datatables.net-bs";


interface IKeyValue {
    key: string;
    value: any;
}

type ActiveTab = "assemblies" | "configuration" | "tenants";

@Component
export default class SiteInfo extends Vue {

    value: Array<any> = null;
    configuration: Array<IKeyValue> = [];
    tenantInfo: Array<IKeyValue> = [];

    activeTab: ActiveTab = "configuration";

    mounted() {
        FetchWrapper.fetch("api/1.0/siteinfo/siteinfos", { method: "get" })
            .then(response => response.json())
        .then(response => this.value = response);

        FetchWrapper.fetch("api/1.0/query/getConfiguration", { method: "get" })
            .then(response => response.json())
            .then(response => this.configuration = response);

        FetchWrapper.fetch("api/1.0/query/getTenantInfo", { method: "get" })
            .then(response => response.json())
            .then(response => this.tenantInfo = response);

    }

    tabChanged(newTab: ActiveTab) {
        this.activeTab = newTab;
        //this.jobsToShow = jobsToShow;
        //this.mainTable.ajax.url(this.getTableAjaxUrl(jobsToShow)).load();

        //        this.populateTable(ident);
    }


}



// WEBPACK FOOTER //
// ./ClientApp/components/site-info/site-info.ts